import Card from "components/molecules/Card/Card";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import MapWidget from "../../widgets/MapWidget/MapWidget";

const MapWidgetBuilder = function ({ isEditMode, isOpen }) {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      {!isEditMode && (
        <p className="choose-widget-title">
          <FormattedMessage id="general.preview" defaultMessage="Preview" />
        </p>
      )}
      {isEditMode && (
        <p className="font-b3 text-secondary text-center">
          <FormattedMessage
            id="dashboard.widgetDialog.mapWidgetBuilder.noPerviewAvailableWhileMapWidgetEnabled"
            defaultMessage="No preview available while map widget is enabled"
          />
        </p>
      )}
      {!isEditMode && isOpen && (
        <div style={{ width: "800px" }}>
          <Card>
            <MapWidget isLayoutLocked isPreview />
          </Card>
        </div>
      )}
    </div>
  );
};

MapWidgetBuilder.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default MapWidgetBuilder;
